// (A) 가공 프로그램 탭 - 순수 포맷/로직 함수. 컴포넌트와 분리해서 단위테스트 가능하게 둔다
// (eqpDiscovery.js와 같은 이유).

export const formatBytes = (bytes) => {
  if (bytes == null) return '-';
  const n = Number(bytes);
  if (!Number.isFinite(n)) return '-';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

// MLSD/MDTM 형식(YYYYMMDDHHMMSS) -> "2026-10-17 15:30:00". 형식이 아니면 원본 그대로.
export const formatMtime = (mtime) => {
  if (!mtime) return '-';
  const m = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/.exec(mtime);
  if (!m) return mtime;
  const [, y, mo, d, h, mi, s] = m;
  return `${y}-${mo}-${d} ${h}:${mi}:${s}`;
};

// 두 버전을 골랐을 때 [이전 버전과 비교] 버튼을 활성화할지 - 정확히 2개, 서로 달라야 함.
export const canCompare = (selectedIds) => Array.isArray(selectedIds) && selectedIds.length === 2
  && selectedIds[0] !== selectedIds[1];

// 비교 다이얼로그에 넘길 때는 "더 오래된 버전"이 from이 되게 정렬(versions는 최신순으로 내려온다).
export const orderForDiff = (selectedIds, versions) => {
  const idx = (id) => versions.findIndex((v) => v.verId === id);
  const [a, b] = selectedIds;
  return idx(a) > idx(b) ? { fromVerId: a, toVerId: b } : { fromVerId: b, toVerId: a };
};
